import {
  ApplicationConfig,
  provideZoneChangeDetection,
  isDevMode,
  inject,
  LOCALE_ID,
  provideAppInitializer,
} from '@angular/core';
import {
  PreloadAllModules,
  provideRouter,
  TitleStrategy,
  withPreloading,
} from '@angular/router';
import { registerLocaleData } from '@angular/common';
import localeVI from '@angular/common/locales/vi';
import localeViExtra from '@angular/common/locales/extra/vi';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { TranslocoHttpLoader } from './shared/services/app/transloco-loader';
import { provideTransloco } from '@jsverse/transloco';
import { provideTranslocoLocale } from '@jsverse/transloco-locale';
import {
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDatepickerI18n,
} from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskConfig, provideEnvironmentNgxMask } from 'ngx-mask';
import dayjs from 'dayjs';
import dayjsCustomParseFormat from 'dayjs/plugin/customParseFormat';
import isBetween from 'dayjs/plugin/isBetween';
import duration from 'dayjs/plugin/duration';
import lunar from 'dayjs-lunar';

import { routes } from './app.routes';
import {
  AppSettingsService,
  CustomAdapter,
  CustomDateParserFormatter,
  CustomGlobalDatepickerI18n,
  I18n,
  PageTitleStrategy,
} from './shared/services/app';
import { authInterceptor, errorInterceptor } from './shared/interceptors';

const initializeApp = () => {
  const appSettings = inject(AppSettingsService);
  return appSettings.load();
};

const maskConfigFunction: () => Partial<NgxMaskConfig> = () => {
  return {
    validation: false,
  };
};

dayjs.extend(dayjsCustomParseFormat);
dayjs.extend(isBetween);
dayjs.extend(duration);
dayjs.extend(lunar);
registerLocaleData(localeVI, 'vi-VN', localeViExtra);
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([errorInterceptor, authInterceptor])),
    provideAppInitializer(initializeApp),
    provideTransloco({
      config: {
        availableLangs: ['en', 'vi'],
        defaultLang: 'vi',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    provideTranslocoLocale({
      langToLocaleMapping: {
        en: 'en-US',
        vi: 'vi-VN',
      },
    }),
    provideEnvironmentNgxMask(maskConfigFunction),
    { provide: TitleStrategy, useClass: PageTitleStrategy },
    I18n,
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    { provide: NgbDatepickerI18n, useClass: CustomGlobalDatepickerI18n },
    { provide: LOCALE_ID, useValue: 'vi-VN' },
  ],
};
